import {Page, NavController} from 'ionic-angular';
import {BulletinService} from '../../services/bulletins';

/*
  Generated class for the BulletinsPage page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Page({
  templateUrl: 'build/pages/bulletins/bulletins.html',
  providers: [BulletinService]
})
export class BulletinsPage {
  bulletins:Array<{date: string, prettyDate: string, title: string, url: string}>;

  constructor(public nav: NavController, bs: BulletinService) {
    this.bulletins = bs.getBulletins();
  }

  itemTapped(event, item) {
    window.open(item.url, '_blank');
  }
}
